module.exports = __webpack_public_path__ + "static/media/meterSettings.0d995148.svg";